export default function Hero() {
  return (
    <section id="hero" className="relative w-full pt-[68px] overflow-hidden">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-16">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full flex flex-col items-start gap-5 md:gap-6">
            <div className="flex flex-wrap items-center gap-2">
              <span className="inline-flex items-center gap-1 px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">
                <i className="ri-fire-line text-sm"></i>每日更新
              </span>
              <span className="inline-flex items-center gap-1 px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 whitespace-nowrap">
                <i className="ri-vip-crown-line text-sm"></i>全本免费
              </span>
              <span className="inline-flex items-center gap-1 px-3 py-1 text-xs font-medium rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">
                <i className="ri-hd-line text-sm"></i>高清画质
              </span>
            </div>

            <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-950 leading-tight tracking-wide">
              UU漫画 · 免费漫画全集在线阅读平台
            </h1>

            <p className="text-base md:text-lg text-primary-500 font-medium">
              海量热门漫画，全集免费看，随时随地畅享阅读乐趣
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[560px]">
              UU漫画汇集全网海量<strong>免费漫画全集</strong>资源，涵盖热血、恋爱、奇幻、悬疑、搞笑等多元题材。无论你喜欢<strong>全集免费看</strong>的经典长篇，还是寻找<strong>免费完整版漫画</strong>的新番连载，这里都能满足你。作为<strong>免费漫画大全</strong>平台，我们每日同步更新最新话，提供<strong>在线免费阅读</strong>的流畅体验，无需注册、无需付费，打开即看。当前热门连载持续追更中，海量完结作品随时畅读，让每一位漫迷都能找到属于自己的<strong>免费漫画资源</strong>。
            </p>

            <div className="flex flex-wrap items-center gap-6 md:gap-8">
              <div className="flex flex-col items-start">
                <span className="text-xl md:text-2xl font-bold text-primary-500">20000+</span>
                <span className="text-xs text-foreground-500">部漫画资源</span>
              </div>
              <div className="flex flex-col items-start">
                <span className="text-xl md:text-2xl font-bold text-accent-500">每日500+</span>
                <span className="text-xs text-foreground-500">话同步更新</span>
              </div>
              <div className="flex flex-col items-start">
                <span className="text-xl md:text-2xl font-bold text-secondary-500">永久免费</span>
                <span className="text-xs text-foreground-500">无隐藏收费</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto">
              <a
                href="#ranking"
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-lg hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-book-open-line text-lg"></i>
                开始阅读
              </a>
              <a
                href="#index"
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-6 py-3 border border-primary-300 text-primary-600 font-medium text-sm rounded-lg hover:bg-primary-50 transition-colors cursor-pointer"
              >
                <i className="ri-grid-line text-lg"></i>
                探索分类
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex items-center justify-center">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20and%20vibrant%20illustration%20of%20a%20cozy%20reading%20nook%20with%20stacks%20of%20colorful%20manga%20books%20and%20comic%20volumes%20spread%20across%20a%20wooden%20desk%2C%20soft%20warm%20lamp%20light%2C%20Japanese%20manga%20art%20style%20background%20elements%2C%20gentle%20ambient%20atmosphere%2C%20cream%20and%20warm%20beige%20background%20with%20subtle%20manga%20panel%20textures%2C%20cozy%20inviting%20feel%2C%20highly%20detailed%20illustration%20with%20rich%20warm%20tones&width=960&height=720&seq=hero-manga-visual-01&orientation=landscape"
                alt="UU漫画免费漫画全集阅读场景"
                className="w-full h-full object-cover"
                onError={(e) => {
                  (e.target as HTMLElement).parentElement!.style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}